import React from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function UiRadioGroup(props) {
	const { value, handleRadioChange, firstValue, firstLabel, secondValue, mainLabel, secondLabel , error } = props;


    return (
        <>
            <FormControl error={error}>
                <FormLabel id="demo-row-radio-buttons-group-label" className='sba-radio-main-label sba-radio-view'>{mainLabel}</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={value}
                    onChange={handleRadioChange}
                >
                    <FormControlLabel value={firstValue} control={<Radio />} label={firstLabel} />
                    <FormControlLabel value={secondValue} control={<Radio />} label={secondLabel} />

                </RadioGroup>
                {error && 
                <FormHelperText>{helperText}</FormHelperText>
                }
            </FormControl>

        </>
    )
}
